<script>
    export default {
        props: {
            name: null,
            label: null,
            value: null,
            lang: null,
            langId: null,
            type: null,
            model: null,
            modelId: null,
            showCounts: {
              type: Boolean,
              default(){
                return false;
              }
            },
        },
        created() {
          this.valueMutable = this.value;
        },
        watch: {
          value(newValue) {
            this.valueMutable = newValue;
            this.save();
          },
        },
        data() {
            return {
                loading: false,
                valueMutable: null,
            }
        },
        methods: {
            save() {
                if (this.valueMutable) {
                    this.loading = true;

                    axios.post(Scoop.baseUrl + '/api/multilang/' + this.model, {
                        'name': this.name,
                        'id': this.modelId,
                        'value': this.valueMutable,
                        'lang': this.langId,
                    }).then(() => {
                        this.loading = false;
                        toastr.success(this.label + ' wurde gespeichert');
                        this.$emit('changed', { value: this.valueMutable });
                    });
                }
            }
        },
        computed: {
            elId(){
                return _.uniqueId('multilang-' + this.name);
            }
        }
    }
</script>

<style>
    .multilang-field textarea {
        width: 100% !important;
    }
</style>

<template>
    <div class="multilang-field">
        <label :for="'multilang-' + name">{{ label }}</label>
        <div class="input-group">
            <span class="loading input-group-addon" v-if="loading">
                <i class="fa fa-spinner fa-spin"></i>
            </span>
            <div v-if="type == 'input'">
                <input :id="elId" type="text" class="form-control" :name="name" v-model="valueMutable"
                       :disabled="loading" @blur="save" @keyup.enter="save">
            </div>
            <div v-else-if="type == 'text'">
                <textarea :id="elId" rows="7" class="form-control" :name="name" v-model="valueMutable"
                          :disabled="loading"
                          @blur="save" @keyup.enter="save">{{ value }}</textarea>
            </div>
            <span class="input-group-addon"><span class="text-uppercase m-r-xs">{{ lang }}</span><i
                    class="fa fa-language"></i></span>
        </div>
        <div class="text-right small p-xxs" v-if="showCounts && valueMutable">{{ valueMutable.length }}</div>
    </div>
</template>
